/**
 * Requires
 */

import $ from 'jquery'
import _throttle from 'lodash/throttle'

/**
 * Initialisation
 */

const $window = $(window)
const $document = $(document)
let $lazyIframes = null
let initedScrollChecker = false

export function initialise() {
  const $button = $('[data-embed-button]')

  $button.on('click', function (event) {
    const $this = $(this)
    const $container = $this.parent('[data-embed-container]')
    const url = $this.data('embed-button')
    const content =
      '<iframe src="' +
      url +
      '" width="1280" height="720" frameborder="0" allowtransparency="true" scrolling="no" allowfullscreen></iframe>'

    $container.empty()
    $container.html(content)

    event.preventDefault()
  })

  $lazyIframes = $('iframe[data-src]')
  if ($lazyIframes.length) {
    startVisibilityChecker()
    handleScroll()
  }
}

function startVisibilityChecker() {
  if (!initedScrollChecker) {
    $document.on('scroll', _throttle(handleScroll, 1000 / 20))
    initedScrollChecker = true
  }
}

function handleScroll() {
  if (!$lazyIframes) return
  const windowHeight = $window.height()
  $lazyIframes.each((i, elem) => {
    const rect = elem.getBoundingClientRect()
    if (rect.top > -400 && rect.top - windowHeight < 400) {
      const $elem = $(elem)
      $elem.attr('src', $elem.attr('data-src')).removeAttr('data-src')
      $lazyIframes = $('iframe[data-src]')
    }
  })
}
